import {ReportRowKind, type ViewRow} from "../../types";
import {RowWarningTag} from "./RowWarningTag.tsx";
import {BadgeVariant} from "./tableStyles.ts";

export function RowBadge({row}: {row: ViewRow}) {
    if (row.warning) return <RowWarningTag />;
    let text: string | null = null;
    let variant = BadgeVariant.Subtotal;
    if (row.kind === ReportRowKind.Subtotal) {
        text = "SUBTOTAAL";
        variant = BadgeVariant.Subtotal;
    } else if (row.kind === ReportRowKind.Kpi || row.kind === ReportRowKind.BalanceCheck) {
        text = "KPI";
        variant = BadgeVariant.Kpi;
    }
    if (!text) return null;
    const cls =
        variant === BadgeVariant.Kpi
            ? "bg-[#EAF5FD] text-[#1E8AD1] border-[#bfe3f8]"
            : "bg-gray-50 text-gray-500 border-gray-300";
    return (
        <span
            className={`ml-2 inline-flex items-center rounded-[4px] border px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-[0.04em] ${cls}`}
        >
            {text}
        </span>
    );
}
